<template>
   <div class="swiper-container">
        <ol class="breadcrumb swiper-no-swiping position-fixed"></ol>
        <!-- Additional required wrapper -->
        <div class="swiper-wrapper">
            <!--SLIDE-1-->
            <div class="swiper-slide overflow-auto swiper-no-swiping" data-title="Actividad de conocimientos previos">
                <div class="container-fluid">
                    <div class="row" id="slide-1">
                        <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 pr-0 p-2 ">
                            <div class="p-3 pl-lg-5">
                                <h2 class="mt-5">Actividad de conocimientos previos</h2>
                                <h3>La adquisición del lenguaje</h3>
                                <h5>Tipo de actividad: foro</h5>
                                <h4 class="mt-3 pt-xl-5 pt-lg-5 pt-3">Objetivo</h4>
                                <p>Identificar los conocimientos previos que presentan los estudiantes sobre la adquisición del lenguaje.</p>
                                <h4 class="mt-3">¿Qué hacer?</h4>
                                <p>Desarrolle el proceso que se enumera a continuación.</p>
                                <div class="row">
                                    <div class="col-12 d-flex">
                                        <span class="numeracionMorada1 mr-2">1</span>
                                        <p>Lea el siguiente fragmento:</p>
                                    </div>
                                    <div class="col-12">
                                        <p>Hoy sabemos que el lenguaje aparece en los dos primeros años del niño en un aprendizaje espontáneo que, si se mira desprevenidamente, es bien admirable por la fluidez y la rapidez natural con que se produce. Dicho aprendizaje implica etapas evolutivas, procesos de adquisición y desarrollo personal y relaciones sociales y culturales, que paulatinamente llevan a la aparición del lenguaje y del pensamiento <a href="#" class="tooltipurl" v-b-popover.click.blur.html="tooltipTermino1">(Niño, 2007, p. 57)</a>.</p>
                                    </div>
                                    <div class="col-12">
                                        <ul class="bulletMorado ml-4">
                                            <li class="bulletMorado">Señale la tesis principal del texto.</li>
                                            <li class="bulletMorado">Identifique dos argumentos que sustenten la idea principal del texto.</li>
                                            <li class="bulletMorado">Escriba en cuatro párrafos su posición argumentativa sobre la tesis del fragmento, tomando como referencia los argumentos dados por el autor.</li>
                                        </ul>
                                    </div>
                                </div>
                                
                                <div class="row mt-3 mb-5">
                                    <div class="col-12 d-flex">
                                        <span class="numeracionMorada1 mr-2">2</span>
                                        <p>Participe en el foro con el texto terminado en un archivo de Word con letra Times New Roman a 12 puntos, interlineado 1.5 y cuya extensión no supere la cuartilla de texto.</p>
                                    </div>
                                </div>
                            
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 offset-xl-1 offset-lg-1 Fondo-CP justify-content-center align-items-center"> 
                            <p class="RefimgActiv">Foto de Tatiana Syrikova en <a href="https://www.pexels.com/es-es/foto/nina-mono-ojos-jugando-3933250/" target='_blank' class="text-white">Pexels</a></p>
                            <div class="w-100 pl-lg-3 pr-lg-3 pl-1 pr-1 pt-5 mt-lg-5 mb-5 pb-5">
                                <div class="row ml-xl-3 ml-lg-1 ml-0 mr-xl-3 mr-lg-1 mr-0 vh-xl-100">
                                    <div class="col-lg-12 col-md-12 col-12 p-lg-5 p-3 d-flex align-items-center justify-content-center">	
                                            <button class="btn BtnPrincipal" onClick="javascript:window.open('http://campusvirtual.itm.edu.co/mod/forum/view.php?id=212103', '_blank');">Ir a foro</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {SwiperController} from '../assets/RecursosITM/js/Swiper'

export default {
    name: 'ConocimientosPrevios',
    data(){
      return{
        tooltipTermino1: '<p style="color: #333333 !important;"><b>Niño Rojas, V. M</b>. (2007). <span class="font-italic">Fundamentos de semiótica y lingüística</span>. Bogotá: Ecoe Ediciones.</p>'
      }
    },
    mounted(){
        SwiperController(),
        document.title = this.$route.meta.title
    }
}
</script>